export default "__VITE_ASSET__DdeE191i__"